(function () {

  function addClassToSecondDivInsideParent(config) {
    const { parentSelector, classToAdd } = config;

    document.querySelectorAll(parentSelector).forEach(parent => {
      const children = parent.children;
      if (children.length >= 2) {
        children[1].classList.add(classToAdd);
      }
    });
  }

  function initSecondDivClass() {
    addClassToSecondDivInsideParent({
      parentSelector: '.parent-parent-view-details-wrapper',
      classToAdd: 'details-middle-block'
    });
    
  }

  // run once
  initSecondDivClass();

  // dynamic / Shopify safe
  new MutationObserver(initSecondDivClass).observe(document.body, {
    childList: true,
    subtree: true
  });

})();



(function () {

  function addClassToFirstDiv() {
    document.querySelectorAll('.advanced-filter').forEach(parent => {
      const firstDiv = parent.querySelector('div');

      if (firstDiv && !firstDiv.classList.contains('advanced-filter-text')) {
        firstDiv.classList.add('advanced-filter-text');
      }
    });
  }

  // Run once
  document.addEventListener('DOMContentLoaded', addClassToFirstDiv);

  // Shopify dynamic reload support
  new MutationObserver(addClassToFirstDiv).observe(document.body, {
    childList: true,
    subtree: true
  });

})();


(function () {

  function addClassTofirstchildDiv() {
    document.querySelectorAll('.advanced-filter-text').forEach(parent => {
      const firstDiv = parent.querySelector('div');

      if (firstDiv && !firstDiv.classList.contains('advanced-filter-title')) {
        firstDiv.classList.add('advanced-filter-title');
      }
    });
  }

  // Run once
  document.addEventListener('DOMContentLoaded', addClassTofirstchildDiv);

  // Shopify dynamic reload support
  new MutationObserver(addClassTofirstchildDiv).observe(document.body, {
    childList: true,
    subtree: true
  });

})();